import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        languageType: 'cn'
    },
    mutations: {
        changeLan(state, data) {
            state.languageType = data
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js